<template>
  <div v-if="changes.length" class="elevation-0 pa-4 ma-0" style="background:white; border-radius:3px;">
    <div v-for="change in changes" :key="change.name" class="pb-2">
      <div class="subheading">{{ change.name }}</div>
      <div>from: {{ formatValue(change.from) }}</div>
      <div>to: {{ formatValue(change.to) }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AdminChange",
  props: ["eventDateObj"],
  computed: {
    changes: function() {
      const params = this.eventDateObj && this.eventDateObj.params
      const metadata = params && params.metadata
      if (metadata && metadata.changedFields && metadata.changedFields.length) {
        return metadata.changedFields
      }
      return []
    }
  },
  methods: {
    formatValue: function(value) {
      if (value === undefined || value === null || value === "") {
        return "—"
      }
      if (typeof value === "string") {
        return value
      }
      try {
        return JSON.stringify(value)
      } catch (err) {
        return String(value)
      }
    }
  }
}
</script>
